var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-parent" }, [
    _c(
      "article",
      { staticClass: "tile is-child box" },
      [
        _vm.selected === ""
          ? _c(
              "table",
              { staticClass: "table is-striped is-narrow is-fullwidth" },
              [
                _vm._m(0),
                _c(
                  "tbody",
                  _vm._l(_vm.mappings, function (c, idx) {
                    return _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !c.isDeleted,
                            expression: "!c.isDeleted",
                          },
                        ],
                        key: idx,
                      },
                      [
                        _c("td", [_vm._v(_vm._s(c.contact.title))]),
                        _c("td", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.select(c.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  `${c.contact.firstName} ${c.contact.lastName}`
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.setDefaultPhone(c.contact.phones))),
                        ]),
                        _c("td", { staticClass: "is-email" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.setDefaultEmail(c.contact.emails))
                            ),
                          ]),
                        ]),
                        _c(
                          "td",
                          { staticClass: "has-text-centered is-content-width" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-small is-inverted is-gold",
                                on: {
                                  click: function ($event) {
                                    return _vm.setDefault(idx)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "mdi mdi-24px",
                                    class: {
                                      "mdi-star": c.isDefault,
                                      "mdi-star-outline": !c.isDefault,
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-small is-primary is-inverted",
                                on: {
                                  click: function ($event) {
                                    return _vm.select(c.id)
                                  },
                                },
                              },
                              [_vm._m(1, true)]
                            ),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-small is-danger is-inverted",
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(idx)
                                  },
                                },
                              },
                              [_vm._m(2, true)]
                            ),
                          ]
                        ),
                        _c("td", { staticClass: "is-content-width" }, [
                          _vm.$v.entity.contacts.$each[idx].$invalid
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "button is-small is-danger is-inverted tooltip is-tooltip-topright is-tooltip-danger",
                                  attrs: {
                                    "data-tooltip": "Validation Errors",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.select(c.id)
                                    },
                                  },
                                },
                                [_vm._m(3, true)]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm.selected === ""
          ? _c(
              "button",
              {
                staticClass: "button is-primary is-pulled-right",
                on: {
                  click: function ($event) {
                    return _vm.addContact()
                  },
                },
              },
              [_vm._m(4)]
            )
          : _vm._e(),
        _vm.selectedContact
          ? _c("contact-component-view", {
              attrs: {
                contact: _vm.selectedContact,
                v: _vm.$v.entity.contacts.$each[_vm.selectedIndex],
              },
              on: {
                back: _vm.back,
                remove: function ($event) {
                  return _vm.remove(_vm.selectedIndex)
                },
                setDefault: function ($event) {
                  return _vm.setDefault(_vm.selectedIndex)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Title")]),
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Phone")]),
        _c("th", [_vm._v("Email")]),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-lead-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-alert mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }